import img1 from "../assets/img/Fruhling-Ammersee-Yoga.JPG";
import img2 from "../assets/img/garten.webp";
import img3 from "../assets/img/winter_isar.webp";
import img4 from "../assets/img/fruhlingsblumen.webp";
import img5 from "../assets/img/katharina-roehler-uRVrsWt-7mU-unsplash.webp";
import img6 from "../assets/img/taylor-wright-s8Yz0dqKrVI-unsplash_edited.webp";
import img7 from "../assets/img/_1080571.webp";
import img8 from "../assets/img/_1033783.webp";
import img9 from "../assets/img/_1035852.webp";

function Galerie() {
  return <div className="main-wrapper">
    
    

    <h2>Galerie</h2>

    <p>
      Die folgenden Fotos sind im Rahmen des Kursangebots der letzten Jahre entstanden.
    </p>

    <h3>2026</h3>

    <img className="left size53" src={img1}/>
    <img className="right size53" src={img2}/>
    <img className="left size53" src={img3}/>

    <h3>2025</h3>

    <img className="right size53" src={img4}/>
    <img className="left size53" src={img5}/>
    <img className="right size53" src={img6}/>

    <h3>2024</h3>

    <img className="left size53" src={img7}/>
    <img className="right size53" src={img8}/>
    <img className="left size53" src={img9}/>


  </div>;
}
export default Galerie;